import { notificationTypes } from "@/constants/miscConstants";
import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import i18next from "i18next";

function makeSingleArray(data) {
  // Initialize an empty array to store the combined result
  const combinedArray = [];
  notificationTypes.forEach((type) => {
    if (Object.prototype.hasOwnProperty.call(data, type)) {
      combinedArray.push(...data[type]);
      combinedArray.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
    }
  });

  return combinedArray;
}

const inboxSlice = createSlice({
  name: "chat",
  initialState: {
    chatInitilizationStates: {
      initilizeChatLoading: false,
      initilizeChatError: null,
      data: {}
    },
    userSpecificChatStates: {
      chatLoading: false,
      userSpecificChatList: [],
      chatError: null
    },
    notificationStates: {
      notificationLoading: false,
      data: []
    },
    loading: false,
    error: null,
    chatUserList: []
  },
  reducers: {
    resetChatsReducer: (state) => {
      state.chatInitilizationStates = {
        ...state.chatInitilizationStates,
        initilizeChatLoading: false,
        initilizeChatError: null,
        data: {}
      };
      state.userSpecificChatStates = {
        ...state.userSpecificChatStates,
        chatLoading: false,
        userSpecificChatList: [],
        chatError: null
      };
      state.loading = false;
      state.error = null;
      state.chatUserList = [];
    },

    upDateSpecificChatList: (state, action) => {
      const { messageDto } = action.payload;

      state.userSpecificChatStates.userSpecificChatList = [
        ...state.userSpecificChatStates.userSpecificChatList,
        messageDto
      ];
      const existingIndex = state.chatUserList?.findIndex(
        (chat) => chat?.conversationId === messageDto.id
      );

      state.chatUserList[existingIndex] = {
        ...state.chatUserList[existingIndex],
        lastMessageTime: messageDto.sendAt,
        lastMessage: messageDto.messageText
      };
    },

    updateSidebarChatList: (state, action) => {
      const inComingNewChatUser = action.payload;

      const existingIndex = state.chatUserList?.findIndex(
        (chatUser) =>
          chatUser.conversationId === inComingNewChatUser.conversationId
      );

      if (existingIndex !== -1) {
        state.chatUserList[existingIndex] = inComingNewChatUser;
      } else {
        state.chatUserList.push(inComingNewChatUser);
      }

      state.chatUserList?.sort(
        (a, b) => new Date(b.lastMessageTime) - new Date(a.lastMessageTime)
      );
    },

    removerSpecificUserChat: (state) => {
      state.userSpecificChatStates.userSpecificChatList = [];
    },

    initilizeChatRequest: (state) => {
      state.chatInitilizationStates = {
        ...state.chatInitilizationStates,
        initilizeChatLoading: true
      };
    },
    initilizeChatSuccess: (state, action) => {
      state.chatInitilizationStates = {
        ...state.chatInitilizationStates,
        initilizeChatLoading: false,
        data: action.payload
      };
    },
    initilizeChatFailure: (state, action) => {
      state.chatInitilizationStates = {
        ...state.chatInitilizationStates,
        initilizeChatLoading: false,
        initilizeChatError:
          action.payload?.response?.data?.details ||
          "Error while creating the new chat"
      };
    },

    getAllChatsRequest: (state) => {
      state.loading = true;
    },
    getAllChatsSuccess: (state, action) => {
      state.chatUserList = action.payload || [];
      state.loading = false;
    },
    getAllChatsFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
    },

    getMessageHistoryRequest: (state) => {
      state.userSpecificChatStates.chatLoading = true;
      state.userSpecificChatStates.chatError = null;
    },
    getMessageHistorySuccess: (state, action) => {
      state.userSpecificChatStates.chatLoading = false;
      state.userSpecificChatStates.userSpecificChatList = action.payload;
    },
    getMessageHistoryFailure: (state, action) => {
      state.userSpecificChatStates.chatLoading = false;
      state.userSpecificChatStates.chatError = action.payload;
    },

    sendMessageRequest: (state) => {
      state.loading = false;
    },
    sendMessageSuccess: (state, action) => {
      state.chatUserList = action.payload;
      state.loading = false;
    },
    sendMessageFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
    },

    notificationRequest: (state, action) => {
      const { notificationId } = action.payload || {};
      state.notificationStates = {
        ...state.notificationStates,
        notificationLoading: !notificationId ? true : false
      };
    },
    notificationSuccess: (state, action) => {
      const makeSingleArrayObject = makeSingleArray(action.payload);
      state.notificationStates = {
        ...state.notificationStates,
        notificationLoading: false,
        data: makeSingleArrayObject || []
      };
    },
    notificationFailure: (state, action) => {
      const { message } = action.payload || {};
      if (message) {
        notification.error({
          message: i18next.t("forgot.errorTitle"),
          description: message
        });
      }
    }
  }
});

export const {
  resetChatsReducer,
  upDateSpecificChatList,
  removerSpecificUserChat,
  updateSidebarChatList,
  initilizeChatRequest,
  initilizeChatSuccess,
  initilizeChatFailure,
  getAllChatsRequest,
  getAllChatsSuccess,
  getAllChatsFailure,
  sendMessageRequest,
  sendMessageSuccess,
  sendMessageFailure,
  getMessageHistoryRequest,
  getMessageHistorySuccess,
  getMessageHistoryFailure,
  notificationRequest,
  notificationSuccess,
  notificationFailure
} = inboxSlice.actions;

export default inboxSlice.reducer;
